import React, { CSSProperties } from 'react';
import { observer } from 'mobx-react-lite';
import { useQueueStore } from '../context/use-queue-store';
import { Grid } from '@cad-arc';
import { QUEUE_GUTTER_WIDTH } from './queue-row-gutter';

function BaseStickyGroupHeader(
    { children, style, ...rest }: { style?: CSSProperties; children: React.ReactNode },
    ref: React.ForwardedRef<HTMLDivElement>
): React.ReactElement {
    const store = useQueueStore();
    const { showsRowGutter, queueColumns } = store.workspacePanel.queue;
    const columnsWidth = `${queueColumns.reduce((acc, column) => acc + column.width, 0)}px`;

    return (
        <Grid
            position="relative"
            // we have to manually adjust the top distance to account for our sticky column header height
            top="22px"
            {...rest}
            ref={ref}
            style={{
                '--fullColumnWidth': showsRowGutter
                    ? `calc(${QUEUE_GUTTER_WIDTH} + ${columnsWidth})`
                    : columnsWidth,
                ...style,
            }}
        >
            {children}
        </Grid>
    );
}

export const StickyGroupHeader = observer(React.forwardRef(BaseStickyGroupHeader));
